export default __webpack_public_path__ + "static/media/47SA64.23d9cb86.png";